import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Layout from "../../components/Layout.js";
import axios from "axios";
import { apiFetch } from "../../api.js";

const API_URL = "//144.143.142.29:5000/api/designations";

const DesignationForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const editData = location.state?.editData || null;
  const [code, setCode] = useState("");
  const [designation, setDesignation] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [ipAddress, setIpAddress] = useState("");
  const [userId, setUserId] = useState("");
  const [serverIp] = useState(window.location.hostname);
  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};

  useEffect(() => {
    if (editData) {
      setCode(editData.code);
      setDesignation(editData.designation);
    }
  }, [editData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      if (!code.trim() || !designation.trim()) {
        setError("Code and Designation are required");
        setLoading(false);
        return;
      }

      const payload = {
        what: editData ? "update" : "insert",
        sp_42: editData ? editData.unqid : null,
        sp_48: code,
        sp_47: designation,
      };

      const res = await apiFetch(API_URL, {
        method: "POST",
        body: JSON.stringify(payload),
      });
      const data = await res.json();

      if (res.ok && data.success) {
        navigate("/designations");
      } else {
        setError(data.message || "Failed to save designation");
      }
    } catch (err) {
      console.error("API Error:", err);
      setError("Server error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleExit = () => {
    navigate("/designations");
  };

  /*------------------- Styles--------------*/
  /*------------------- Styles--------------*/

  const pageContainerStyle = {
    width: "100%",
    minHeight: "100vh",
    backgroundColor: "#f4f6f8",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "10px",
    boxSizing: "border-box",
  };

  const containerStyle = {
    width: "100%",
    maxWidth: "1200px",
    padding: "16px",
    borderRadius: "8px",
    backgroundColor: "#fff",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    boxSizing: "border-box",
  };

  const headerStyle = {
    border: "2px solid #8B1E3F",
    borderRadius: "6px",
    padding: "15px",
    marginBottom: "20px",
    textAlign: "center",
    background: "#8B1E3F",
    fontWeight: "bold",
    fontSize: "1.5rem",
    color: "#fff",
  };

  const errorStyle = {
    color: "red",
    marginBottom: "15px",
    textAlign: "center",
  };

  /* ✅ RESPONSIVE GRID */
  const inputContainerStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
    gap: "16px",
    width: "100%",
  };

  const inputWrapperStyle = {
    display: "flex",
    flexDirection: "column",
  };

  const inputStyle = {
    width: "100%",
    padding: "10px",
    marginTop: "5px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
  };

  /* ✅ CENTERED RESPONSIVE BUTTONS */
  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    marginTop: "20px",
    width: "100%",
    minHeight: "100%",
  };

  const buttonStyle = (bgColor) => ({
    minWidth: "120px",
    height: "42px",
    padding: "0 22px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    whiteSpace: "nowrap",
  });

  return (
    <Layout>
      <div style={pageContainerStyle}>
        <div style={containerStyle}>
          <div style={headerStyle}>
            {editData ? "Edit Designation" : "Add Designation"}
          </div>

          {error && <div style={errorStyle}>{error}</div>}
          <br></br>
          <form onSubmit={handleSubmit}>
            <div style={inputContainerStyle}>
              <div style={inputWrapperStyle}>
                <label>Code:</label>
                <input
                  type="text"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  required
                  style={inputStyle}
                />
              </div>

              <div style={inputWrapperStyle}>
                <label>Designation:</label>
                <input
                  type="text"
                  value={designation}
                  onChange={(e) => setDesignation(e.target.value)}
                  required
                  style={inputStyle}
                />
              </div>
            </div>
            <br></br>
            <div style={buttonContainerStyle}>
              <button
                type="submit"
                disabled={loading}
                style={buttonStyle("#4CAF50")}
              >
                {loading ? "Saving..." : "Save"}
              </button>
              <button
                type="button"
                onClick={handleExit}
                style={buttonStyle("#ab2025")}
              >
                Exit
              </button>
            </div>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default DesignationForm;
